export default function SectionHeader({ title, action, subtitle }) {
    return (
      <div className="section-header">
        <div>
          <h2 className="section-header__title">{title}</h2>
          {subtitle && <p className="section-header__subtitle">{subtitle}</p>}
        </div>
        {action}
      </div>
    );
  }